// utils/constants.js

export const API_BASE_URL = 'https://aseanphoneshop-backend.onrender.com/api';
export const STATIC_BASE_URL = 'https://aseanphoneshop-backend.onrender.com';

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  ME: '/auth/me',
  
  // Products
  PRODUCTS: '/products',
  PRODUCT_DETAIL: (id) => `/products/${id}`,
  
  // Categories
  CATEGORIES: '/categories',
  CATEGORY_DETAIL: (id) => `/categories/${id}`,
  
  // Repairs
  REPAIRS: '/repairs',
  REPAIR_DETAIL: (id) => `/repairs/${id}`,
  
  // Images
  DELETE_IMAGE: (imageId) => `/images/${imageId}`,
  
  // Backup & Export
  BACKUP_EXPORT: '/backup/export',
  BACKUP_IMPORT: '/backup/import',
  EXPORT_EXCEL: (dataType) => `/export/excel/${dataType}`,
  EXPORT_JSON: (dataType) => `/export/json/${dataType}`,
};

export const ADMIN_EMAIL = '';

// Helper function to get full image URL
export const getImageUrl = (imagePath, subfolder = 'products') => {
  if (!imagePath) {
    return `${STATIC_BASE_URL}/placeholder-image.jpg`;
  }
  
  // If it's already a full URL
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If it's already a relative URL with /uploads
  if (imagePath.startsWith('/uploads')) {
    return `${STATIC_BASE_URL}${imagePath}`;
  }
  
  // Remove any leading slashes
  let filename = imagePath.replace(/^\/+/, '');
  
  // Remove any subfolder prefixes
  if (filename.startsWith('products/')) {
    filename = filename.replace('products/', '');
  }
  if (filename.startsWith('repairs/')) {
    filename = filename.replace('repairs/', '');
  }
  
  // Construct the full URL
  return `${STATIC_BASE_URL}/uploads/${subfolder}/${filename}`;
};

// Process product images - adds fullUrl field
export const processProductImages = (product) => {
  if (!product) return product;
  
  const processedProduct = { ...product };
  
  if (processedProduct.images && Array.isArray(processedProduct.images)) {
    processedProduct.images = processedProduct.images.map(image => ({
      ...image,
      fullUrl: getImageUrl(image.filepath, 'products'),
      url: getImageUrl(image.filepath, 'products')
    }));
  }
  
  // Set main image for convenience
  if (processedProduct.images && processedProduct.images.length > 0) {
    processedProduct.mainImage = processedProduct.images[0].fullUrl;
  }
  
  // Calculate final price
  if (processedProduct.price) {
    processedProduct.finalPrice = processedProduct.discount_percent 
      ? processedProduct.price * (1 - processedProduct.discount_percent / 100)
      : processedProduct.price;
  }
  
  return processedProduct;
};

// Process repair images - adds fullUrl field
export const processRepairImages = (repair) => {
  if (!repair) return repair;
  
  const processedRepair = { ...repair };
  
  if (processedRepair.images && Array.isArray(processedRepair.images)) {
    processedRepair.images = processedRepair.images.map(image => ({
      ...image,
      fullUrl: getImageUrl(image.filepath, 'repairs'),
      url: getImageUrl(image.filepath, 'repairs')
    }));
  }
  
  if (processedRepair.images && processedRepair.images.length > 0) {
    processedRepair.mainImage = processedRepair.images[0].fullUrl;
  }
  
  return processedRepair;
};

// Process array of products
export const processProductsArray = (products) => {
  if (!Array.isArray(products)) return products;
  return products.map(product => processProductImages(product));
};

// Process array of repairs
export const processRepairsArray = (repairs) => {
  if (!Array.isArray(repairs)) return repairs;
  return repairs.map(repair => processRepairImages(repair));
};

// Backward compatibility
export const IMAGE_BASE_URL = STATIC_BASE_URL;